import React from 'react';
import { connect } from 'react-redux';
import { checkRequired, clientErrors } from '@/utils/errors';
import fields from '@/constants/fields';
import DatasetConditionContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/DatasetConditionContainer';
import WorkspaceLocationsConditionDropdown from './WorkspaceLocationsConditionDropdown';

export const validateWorkspaceLocationsContext = (datasetCondition, errors) => {
  checkRequired(
    datasetCondition.context.locations,
    [fields.NAME],
    errors,
    'dataset.condition',
    'dataset.condition.validation.invalid.title',
    true,
  );
};

const WorkspaceLocationsCondition = ({ datasetCondition, updateProperties, saveErrors }) => {
  const namesError = clientErrors(saveErrors).find((e) => e.fields.includes(fields.NAME));
  return (
    <DatasetConditionContainer
      error={namesError}
      htmlFor="ADDUC_0007_locations"
      labelId="dataset.condition.workspace.locations.label"
    >
      <WorkspaceLocationsConditionDropdown
        datasetCondition={datasetCondition}
        error={namesError}
        updateProperties={updateProperties}
      />
    </DatasetConditionContainer>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceLocationsCondition);
